import { render, staticRenderFns } from "./ExposomeGlobe.vue?vue&type=template&id=af3e539e&scoped=true&"
import script from "./ExposomeGlobe.vue?vue&type=script&lang=ts&"
export * from "./ExposomeGlobe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3e539e",
  null
  
)

export default component.exports